import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import H4 from 'UIComponents/elements/headings/H4';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DelayMessage({
  delayEnrollmentCount,
  flowObjectTypeId,
  moveAllChildren
}) {
  const delayMessageKey = moveAllChildren ? 'automation.moveActionCanvas.confirmationPopover.enrolledObjectsConfirmation.allActions_cob' : 'automation.moveActionCanvas.confirmationPopover.enrolledObjectsConfirmation.thisAction_cob';
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: delayMessageKey,
    objectTypeId: flowObjectTypeId,
    options: {
      // bad types on the `options` prop here. need to allow more than strings
      count: delayEnrollmentCount
    }
  });
}
export default class MoveActionConfirmationPopover extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      savePending: false
    };
    this.onSaveClick = () => {
      const {
        onSave
      } = this.props;
      this.setState({
        savePending: true
      }, onSave);
    };
  }
  renderHeader() {
    const {
      moveAllChildren,
      errorKey
    } = this.props;
    const headerMessageKey = moveAllChildren ? 'automation.moveActionCanvas.confirmationPopover.confirmMove.allActions' : 'automation.moveActionCanvas.confirmationPopover.confirmMove.thisAction';
    if (errorKey) {
      return /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: errorKey
        })
      });
    } else {
      return /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: headerMessageKey
        })
      });
    }
  }
  renderBody() {
    const {
      flowObjectTypeId,
      delayEnrollmentCount,
      changeRemovesGoToEdges,
      cloneAction,
      moveAllChildren
    } = this.props;
    let gotoWarningMessageKey;
    if (cloneAction) {
      if (moveAllChildren) {
        gotoWarningMessageKey = 'automation.moveActionCanvas.confirmationPopover.goToActionWarning.clone.allActions';
      } else {
        gotoWarningMessageKey = 'automation.moveActionCanvas.confirmationPopover.goToActionWarning.clone.thisAction';
      }
    } else {
      if (moveAllChildren) {
        gotoWarningMessageKey = 'automation.moveActionCanvas.confirmationPopover.goToActionWarning.move.allActions';
      } else {
        gotoWarningMessageKey = 'automation.moveActionCanvas.confirmationPopover.goToActionWarning.move.thisAction';
      }
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [delayEnrollmentCount && delayEnrollmentCount > 0 ? /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(DelayMessage, {
          delayEnrollmentCount: delayEnrollmentCount,
          flowObjectTypeId: flowObjectTypeId,
          moveAllChildren: moveAllChildren
        })
      }) : null, changeRemovesGoToEdges && /*#__PURE__*/_jsx(UIAlert, {
        use: "inline",
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: gotoWarningMessageKey
        })
      })]
    });
  }
  render() {
    const {
      children,
      errorKey,
      onCancel
    } = this.props;
    const {
      savePending
    } = this.state;
    const saveDisabled = errorKey !== '';
    return /*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      children: /*#__PURE__*/_jsx(UIPopover, {
        open: true,
        placement: 'top',
        width: "350px",
        content: {
          header: this.renderHeader(),
          body: this.renderBody(),
          footer: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(UILoadingButton, {
              use: "primary",
              onClick: this.onSaveClick,
              disabled: saveDisabled,
              failed: saveDisabled,
              loading: savePending && !saveDisabled,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.moveActionCanvas.confirmationPopover.save"
              })
            }), /*#__PURE__*/_jsx(UIButton, {
              use: "secondary",
              onClick: onCancel,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.moveActionCanvas.confirmationPopover.cancel"
              })
            })]
          })
        },
        children: children
      })
    });
  }
}
MoveActionConfirmationPopover.defaultProps = {
  delayEnrollmentCount: 0,
  errorKey: ''
};